import { useNavigate } from 'react-router-dom'
import { Tabs, TabsContainer } from 'styling/GlobalStyles'
import { opsDepartments } from '../Shared/opsDepartments'
import { SwitcherRow } from './OpsToday.styled'

export const TodaySwitcher = ({ activeKey }: { activeKey: string }) => {
  const navigate = useNavigate()
  return (
    <SwitcherRow>
      <TabsContainer>
        <Tabs active={activeKey === 'site'} onClick={() => navigate('/operations')}>
          Site
        </Tabs>
        {opsDepartments().map((d) => (
          <Tabs key={d.key} active={activeKey === d.key} onClick={() => navigate(`/operations/d/${d.key}`)}>
            {d.name}
          </Tabs>
        ))}
      </TabsContainer>
    </SwitcherRow>
  )
}
